export const FRANCE_CONNECT_REDIRECTION_RULES = {
  signup: {
    admin: "/signup/company",
    employee: "/home",
    ignoreNext: true
  },
  login: {
    default: null,
    ignoreNext: false
  }
};
